import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import ImgPlaceHolder from '../../constant/imgPlaceholder';
import { DoctorEnquiryform } from '../../constant/validation';
import { dashboardAction, departmentAction } from '../../redux/action';
import { ROUTE } from '../../route/Route';
import BreadCrumb from '../breadcrumb/BreadCrumb';
import SectionLoader from '../LodingScreen/SectionLoader';
import SeoAdd from '../Seo/SeoAdd';
import SubmitForm from '../SubmitForm/SubmitForm';
import AvailabelTest from './component/AvailabelTest';
import DoctorTeam from './component/DoctorTeam';
import Instrument from './component/Instrument';
import Staff from './component/Staff';
import { useTranslation } from "react-i18next";

function DepartmentDetails() {
  const { t } = useTranslation();
  const { slug } = useParams<any>();
  const dispatch = useDispatch();
  const departmentDt = useSelector((state: any) => state.department.selected ? state.department.selected : {});
  const departmentData = useSelector((state: any) => state.department.selected?.DepartmentDetails ? state.department.selected?.DepartmentDetails : {});
  const baseUrl = useSelector((state: any) => state.department.selected?.InstrumentsBaseUrl);

  useEffect(() => {
    window?.scrollTo(0, 0);
    if(slug){
      dispatch(departmentAction.getDepartmentBySlugAction(slug));
    }
    return () => { };
  }, [slug]);

  useEffect(() => {
    dispatch(dashboardAction.getCityAction({ id: "" }));
    return () => { }
  }, [])
  return (
    <>
      <SeoAdd slug={ROUTE.DEPARTMENT + '/' + slug} />
      <BreadCrumb page={"Department"} data={{ slug: slug, path: ROUTE.DEPARTMENT }} />
      <>
        <section className="bg-white section overview-top pt-3 paddingBtmZero">
          <div className="container" id="section2">
            <div className="row">
              <div className="col-md-12">
                <div className="overview-wrap text-center">
                  {departmentDt && Object.keys(departmentDt)?.length > 0 ?
                    <img src={departmentData?.MainBanner ? departmentData?.MainBanner : "/assets/img/department_detail.png"} onError={(e: any) => ImgPlaceHolder(e, "/assets/img/department_detail.png")} className="scale" alt="" />
                    :
                    <SectionLoader />
                  }
                  <div className="headingmains text-center pb-lg-3">
                    <h1 className="right aos-init pb-2 mt-3 mt-lg-5">{t(departmentData?.DepartmentName)}</h1>
                  </div>
                  <p dangerouslySetInnerHTML={{ __html: departmentData?.Description }}></p>
              </div>
            </div>
          </div>
          </div>
        </section>
        <Instrument instruments={departmentData?.Instruments} BaseUrl={baseUrl} />
        <DoctorTeam departmentId={departmentData?.Id} />
        {/* <Staff Structure={departmentData?.Structure} TeamImage={departmentData?.TeamImage}/>	 */}
        <AvailabelTest departmentId={departmentData?.Id} DepartmentName={departmentData?.DepartmentName}></AvailabelTest>
        <SubmitForm heading={"Reach Out to Us"} des={departmentData?.DepartmentName} PageSrc={"DepartmentDetail"} validationSchema={DoctorEnquiryform} />
      </>
    </>
  )
}

export default DepartmentDetails
